<template>
  <div class="box">
    <main class="privacy-container">
      <h1>上海律师隐私政策</h1>
      <p><strong>生效日期：2021年9月1日</strong></p>
      <p>
        欢迎使用由上海市律师协会提供并由北京飞书科技有限公司（简称“<strong>我们</strong>”）提供运维技术支持的“上海律师”产品和服务（以下简称“<strong>本平台</strong>”）。
      </p>
      <p>
        本隐私政策列明了在您访问或使用本平台时，我们如何处理、收集、使用和披露您的个人信息。
      </p>
      <p>
        本隐私政策构成您与我们之间具法律约束力的协议，我们在此特别提醒您认真阅读、充分理解本协议各条款，特别是其中所涉及的免除、减轻我们责任的条款、对您权利限制条款、争议解决和法律适用等。<strong>其中，限制、免责条款可能以黑体加粗或加下划线的形式提示您重点注意。</strong>请您审慎阅读并选择接受或不接受本协议。若您不同意本隐私政策，请您停止访问或使用本平台。
      </p>
      <p>
        通讯录、地理位置、摄像头、麦克风、相册权限，均不会默认开启，只有经过您的明示授权才会在为实现特定功能或服务时使用，您也可以撤回授权。<strong>特别需要指出的是，即使经过了您的授权，我们获得了这些敏感权限，也不会在相关功能或服务不需要时收集这些信息。<a href="https://www.feishu.cn/legal/feishu-app-permissions"
             target="_blank">上海律师应用权限申请与使用情况说明。</a></strong>
      </p>
      <p>
        在您仔细阅读下文，了解我们如何处理您的个人信息，以及我们的实际操作方法之前，我们先向您简要告知本隐私政策的基本架构，您可点击相应标题直接查看您所关心的内容。
      </p>
      <p>
        <a href="#toc01"><strong>一、基本定义</strong></a>
      </p>
      <p>
        <a href="#toc02"><strong>二、我们在本平台内收集的个人信息</strong></a>
      </p>
      <p>
        <a href="#toc03"><strong>三、我们如何使用您的个人信息</strong></a>
      </p>
      <p>
        <a href="#toc04"><strong>四、我们如何使用 Cookie 和同类技术</strong></a>
      </p>
      <p>
        <a href="#toc05"><strong>五、我们如何共享、转让、公开披露您的个人信息</strong></a>
      </p>
      <p>
        <a href="#toc06"><strong>六、我们在何处存储您的个人信息</strong></a>
      </p>
      <p>
        <a href="#toc07"><strong>七、我们如何保护您的个人信息的安全</strong></a>
      </p>
      <p>
        <a href="#toc08"><strong>八、您的权利</strong></a>
      </p>
      <p>
        <a href="#toc09"><strong>九、变更</strong></a>
      </p>
      <p>
        <a href="#toc10"><strong>十、联系方式</strong></a>
      </p>
      <p>
        <a href="#toc11"><strong>十一、其他</strong></a>
      </p>
      <h2><a id="toc01"></a><strong>一、基本定义</strong></h2>
      <p>
        “个人信息”指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
      </p>
      <p>
        “个人敏感信息”指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，包括身份证件号码、个人生物识别信息、通信记录和内容、财产信息、行踪轨迹、健康生理信息、交易信息等。
      </p>
      <p>
        “去标识化”是指通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体的过程。
      </p>
      <p>
        “匿名化”是指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。
      </p>
      <h2><a id="toc02"></a><strong>二、我们在本平台内收集的个人信息</strong></h2>
      <p>在您使用本平台服务的过程中，我们可能收集如下几类个人信息。</p>
      <p>1.个人基本资料：律师会员号、实习证号、身份证号、手机号、姓名、头像、电话号码、邮箱</p>
      <p>2.个人工作信息：职业机构、执业证类别</p>
      <p>3.网络身份标识信息：帐户、IP地址</p>
      <p>4.个人沟通信息：上传、发布、提交或发送的讯息、聊天、文件、日历信息</p>
      <p>5.联系人信息：手机通讯录、联系人、群列表</p>
      <p>6.个人上网记录：操作日志，包括软件使用记录、搜索记录、点击记录、Cookies</p>
      <p>
        7.个人常用设备信息：包括硬件设备型号、系统类型、系统版本、设备屏幕尺寸、硬件设备序列号、MAC地址、唯一设备识别码（IMEI、Android ID、IDFA、OpenUDID、SIM卡IMSI信息）、时区、语言设置
      </p>
      <p>
        8.个人位置信息：GPS信息、WLAN接入点、蓝牙和基站等传感器信息、行程安排、旅居情况
      </p>
      <p>9.个人健康生理信息：体温、就诊情况（仅新冠病毒疫情期间）</p>
      <p>
        请注意，上述所列的信息类型中，存在部分信息若单独使用，如操作日志信息属于无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将有可能被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。
      </p>
      <h2><a id="toc03"></a><strong>三、我们如何使用您的个人信息</strong></h2>
      <p>
        （一） 平台的基本业务功能需要依赖部分信息才得以正常安全运行，因此需要您向我们提供或允许我们收集如下信息
      </p>
      <p><strong>1、认证功能</strong></p>
      <p>
        <strong>当你使用本平台，您需要提供会员号/执业证号/手机号/身份证号/实习人员实习证号，上述信息为认证您的执业律师或实习人员身份，若您不提供这类信息，您将无法正常使用本平台。当您登录帐户后还可以选择是否上传头像以加强个性化展示。</strong>
      </p>
      <p><strong>2、会员服务</strong></p>
      <p>
        <strong>当您使用电子执业证和证明申请服务，为确保您本人使用，您需要通过面部识别进行认证进入；</strong>当您使用律师云学院、律师黄页、公益申报等其他会员服务时，我们还将通过上海律师主管部门获取您的相关信息，包括您的姓名、<strong>身份证号码</strong>、联系电话、<strong>执业证号</strong>、执业类型、邮箱地址等。
      </p>
      <p><strong>3、即时沟通</strong></p>
      <p>
        <strong>为了保证新成员加入群组时可随时随地查看全部历史消息，提升上手效率，我们将获取您的消息记录存储在云端服务器中，并会自动同步到所有设备。</strong>
      </p>
      <p>
        <strong>在紧急情况下，为了推进消息的快速触达，我们会通过使用您在注册时提供的手机号码向您推送短信或电话，以帮助其他用户提醒您查看信息。</strong>
      </p>
      <p><strong>4、日历服务</strong></p>
      <p>
        您可通过本平台的日历功能添加工作状态（出差中/请假中/会议中）和事件提醒，订阅同事的日程并发送会议邀请。我们将收集并同步您在平台中处理的日程相关沟通信息，以便在日历功能中展示，帮助您创建管理日历信息、安排任务及提醒您相关日程事项安排，例如当您选择接收、拒绝或待定会议邀请时，该等回复会在日历中标注。如果您是一个日历的控制方，您可将您自己的日历隐私设置为私密、公开或在特定范围中公开。您可订阅其他用户的日历，但前提是其同意您查看其日历。
      </p>
      <p><strong>5、云文档服务</strong></p>
      <p>
        您可通过本平台的云文档功能，多人同时查看和编辑存储在云盘中的文档，并可添加评论和实时接收文档会话。为了使参与文档协同的用户清晰明确的知晓文档编辑信息，在您发布文档内容、评论时，我们将收集您发布的信息，并展示您的姓名、头像、发布内容。此外，您可根据不同的需求对文档共享和编辑的通知范围进行设置。
      </p>
      <p>6、音视频会议功能</p>
      <p>
        为了实现在平台内的音视频会议功能，或与机器人实现语音交互。您需要开启<strong>麦克风或相机/摄像头权限权限</strong>，同时需要请您知晓的是，即使您已同意开启上述权限，我们也仅会在您主动点击客户端内麦克风/摄像头图标时获取语音视频信息。
      </p>
      <p>7、安全监测</p>
      <p>
        为提高您使用本平台的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规的情况，在您使用本平台时，我们会自动收集您的IP地址、设备唯一标识符、硬件的型号和设置、操作系统及应用程序功能（如MAC地址）以及您对我们服务的详细使用情况，如浏览记录、时区、区域和语言设置、服务器日志（包括访问日期和时间）、应用程序崩溃信息来综合判断您帐户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。
      </p>
      <p>
        （二）为了提升服务体验和我们改善服务质量，您可自主选择向我们提供或允许我们收集如下信息
      </p>
      <p><strong>1、人脸认证功能</strong></p>
      <p>
        <strong>为进行身份核验，我们可能会收集你主动提供的人脸图像信息，并将您提供的人脸信息进行比对核验。上述信息属于敏感信息，拒绝提供该信息仅会使你无法使用电子执业证和证明申请功能，但不影响你正常使用本平台的其他功能。</strong>
      </p>
      <p><strong>2、AI辅助功能</strong></p>
      <p>
        <strong>为了帮助您提高信息获取的效率，我们借助AI技术提供了语音转文字和搜索推荐功能，对此我们需要获取用户的沟通内容及搜索内容。在特定情况下我们会对搜索内容进行技术处理后提供给第三方，由其对搜索推荐功能的优化提供技术支持，您知晓并确认在此情形下第三方是无法将上述信息与任何个人关联的。</strong>
      </p>
      <p><strong>3、地理位置信息</strong></p>
      <p>
        如您希望在使用日历功能时配有安排会议室的功能，则您需要授权我们获得您的SIM卡、IP地址以及移动装置地址设定的地点信息，以及使用GPS所得的地点信息（如您的移动装置启动该功能）。我们会使用该等信息以向您提供基于地点位置的相关服务。如果您拒绝提供地点信息，我们将不会基于地点位置向您提供相关服务，但不会影响平台其他功能与服务的正常使用。
      </p>
      <p>4、工作台</p>
      <p>
        为了向您提供更加全面便捷的服务，我们在工作台中会预装部分应用程序，如您选择不使用某一预装应用，可在工作台中对预装应用进行删除处理；删除预装应用并不会影响您正常使用本平台的其他功能/应用。当您使用第三方应用时，此时由第三方处理您的个人信息，请您注意阅读并遵守第三方的个人信息保护政策。
      </p>
      <p><strong>5、邀请外部联系人功能</strong></p>
      <p>
        <strong>我们会收集你主动提供的手机通讯录信息，以匹配外部联系人。上述信息仅用于匹配好友，我们不会保存资料或作为他用。上述信息属于敏感信息，拒绝提供该信息仅会使你无法使用上述功能，但不影响你正常使用本平台的其他功能。</strong>
      </p>
      <p>
        <strong>如果您选择分享口令、邀请链接或二维码邀请外部联系人，我们会调取您的头像、姓名、职位及组织信息并仅在您设备本地的剪贴板上完成口令、链接或二维码的生成，请您注意在使用上述方式邀请外部联系人时会公开您的头像、姓名、职位及组织信息。</strong>
      </p>
      <p><strong>6、服务优化功能</strong></p>
      <p>
        <strong>为向您提供更好、更个性化的服务，例如在不同的服务端或设备上提供更个性化但体验一致的服务，更契合您需求的搜索推荐、客服接待或信息推送，了解产品适配性，我们将收集您的偏好等操作、使用行为信息、地点信息、设备信息。</strong>
      </p>
      <p>
        <strong>上述信息或功能并非平台运行所必需，我们不会强制要求您提供这些信息，您如拒绝不会对您正常使用本平台产生不利影响。</strong>
      </p>
      <p>
        <strong>我们会采取合理可行的措施，尽力避免收集与使用目的无关的个人信息。如果我们使用您的个人信息超出了与使用所声称的目的及具有直接或合理关联的范围，我们将在使用您的个人信息前另外向您告知并征得您的明示同意。</strong>
      </p>
      <p>
        <strong>如我们停止运营本平台服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以提前60天以公告的形式通知您，并依照所适用的法律对所持有的您的个人信息进行删除或匿名化处理。</strong>
      </p>
      <h2><a id="toc04"></a><strong>四、我们如何使用 Cookie 和同类技术</strong></h2>
      <p>
        我们使用Cookies和其它类似技术（例如web beacons、Flash cookies等）（简称“Cookies”），以提升您使用本平台的体验。当您使用本平台服务时，我们可能会使用相关技术向您的设备发送一个或多个 Cookie 或匿名标识符，以收集和存储您访问、使用本产品时的信息。
      </p>
      <p>
        大部分网络浏览器自动接受Cookies，具体是否接受您可以通过设置予以决定。您理解并同意，我们可能存放绝对必要的Cookies即本平台的运行所需要的Cookies，包括让您能够登录本平台安全区域的Cookies。我们存放Cookies将在您终止网站会话或15天后失效。前述存放绝对必要的Cookies行为是本平提供基本服务内容的绝对必要条件，如您不同意相关授权，您无法使用本平台任何服务。
      </p>
      <h2><a id="toc05"></a><strong>五、我们如何共享、转让、公开披露您的个人信息</strong></h2>
      <p><strong>（一）个人信息的共享</strong></p>
      <p>
        <strong>1、我们不会向第三方共享、转让您的个人信息，除非经过您本人事先授权同意，或者共享、转让的个人信息是去标识化处理后的信息，且共享第三方无法重新识别此类信息的个人信息主体。</strong>
      </p>
      <p>2、<strong>共享您的个人信息，我们将遵循如下原则：</strong></p>
      <p>
        <strong>授权同意原则：</strong>未经您的同意，我们不会共享您的个人信息，除非共享的个人信息是去标识化处理后的信息，且共享第三方无法重新识别此类信息的自然人主体。如果第三方使用信息的目的超越原授权同意范围，他们需要重新征得您的同意。
      </p>
      <p>
        <strong>合法正当与最小必要原则：</strong>共享的数据必须具有合法正当目的，且共享的数据以达成目的必要为限。
      </p>
      <p>
        <strong>安全审慎原则：</strong>我们将审慎评估第三方使用共享信息的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护数据安全。
      </p>
      <p>3、实现功能或服务的共享信息</p>
      <p>
        （1）我们会基于律师主管部门（包括律师协会和司法行政机关）的管理要求，向其共享您使用本平台业务功能的使用记录。
      </p>
      <p>
        （2）为在平台完成支付服务，保障您的合法权益，防范欺诈、赌博等风险，维护平台及支付相关功能的安全稳定运行，我们需要向提供平台钱包功能的第三方服务商获取您实际使用的支付帐户的用户标识信息。
      </p>
      <p>
        （3）登录、绑定本平台内产品：经您同意，当您使用本平台帐号登录第三方的产品或服务时，或将帐号与其他第三方帐号绑定，我们会将您的基础信息（姓名、头像）及其他您授权的信息与前述产品或服务共享。
      </p>
      <p>
        （4）定位服务提供商：我们会将您去标识化的位置信息，交由定位服务提供商，用以在日历功能中为您提供更精准的定位。
      </p>
      <p>
        （5）其他辅助处理程序支持方：您理解并同意，为保障本平台相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方提供的软件开发包（SDK）实现相关目的。我们会对合作方获取信息的软件工具开发包（<a href="https://www.feishu.cn/legal/feishu-sdk"
           target="_blank">SDK</a>）进行严格的安全监测，以保护数据安全。我们对接入的相关第三方SDK在目录中列明。
      </p>
      <p>
        <strong>我们只会与第三方共享实现目的所必要的信息，您理解并授权此种情况下我们的信息共享行为。如果第三方因业务需要，确需超出前述使用目的而使用个人信息的，该第三方将需再次征求您的同意。</strong>
      </p>
      <p>
        和第三方合作前，我们会尽合理努力对该第三方的安全能力进行检测，评估向其共享相关信息的正当合法必要性，并与第三方签订保密协议，对其查询行为进行技术监测，督促第三方在使用用户信息时遵守法律法规及协议中约定的保密和安全措施。
      </p>
      <p><strong>（二）个人信息的转让</strong></p>
      <p>
        除非因为可能的合并、收购、资产转让，您的个人信息有可能因此而被转移，否则我们不会转让你的个人信息。在发生前述变更时，我们将按照法律法规及不低于本隐私政策所要求的安全标准继续保护或要求个人信息的继受方继续保护您的个人信息，否则我们将要求继受方重新征得您的授权同意。
      </p>
      <p><strong>（三）个人信息的公开披露</strong></p>
      <p>
        <strong>我们不会公开披露您的信息，除非获得您的同意。但根据法律、法规、规章、其他规范性文件、强制性的行政执法或司法要求，在必须提供您个人信息的情况下，我们可能会依据要求的个人信息类型和披露方式向行政执法或司法机构披露您的个人信息。当我们接到披露请求时，在符合法律法规的前提下，我们要求其必须出具与之相应的法律证明文件，我们仅提供执法、司法部门因特定调查目的且有合法权力获取的数据。在法律法规许可的前提下，我们披露的文件均在加密措施的保护之下。</strong>
      </p>
      <p>
        请您理解，在下列情形中，根据法律法规及国家标准，我们共享、转让、公开披露您的个人信息行为无需征得您的授权同意：
      </p>
      <p>（1）与国家安全、国防安全直接相关的；</p>
      <p>（2）与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p>（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
      <p>
        （4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的，但法律法规明确禁止的情形除外；
      </p>
      <p>（5）您自行向社会公众公开的个人信息；</p>
      <p>
        （6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
      </p>
      <p>
        <strong>根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的处理将无需另行向您通知并征得您的同意。</strong>
      </p>
      <h2><a id="toc06"></a><strong>六、我们在何处存储您的个人信息</strong></h2>
      <p><strong>（一）存储地点：</strong></p>
      <p>
        我们依照法律法规的规定，将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。目前，我们不会将上述信息传输至境外，如果我们向境外传输，我们将会遵循相关国家规定或者征求您的同意。
      </p>
      <p><strong>（二）存储期限：</strong></p>
      <p>
        您在使用本平台期间，我们将持续保存您的个人信息，保存期限将以不超过为您提供服务所必须的期间为原则。在您终止使用本平台或关闭相应授权后，除法律法规对于特定信息保留期限另有规定外，我们会对您的信息进行删除或做匿名化处理。如我们停止运营本平台服务，我们将在合理期限内依照所适用的法律对所持有的您的个人信息进行删除或匿名化处理。
      </p>
      <h2><a id="toc07"></a><strong>七、我们如何保护您的个人信息的安全</strong></h2>
      <p>
        （一）我们非常重视您个人信息的安全。目前，本平台已经通过了国家信息安全等级保护（三级）的测评和备案，并通过了国际权威的ISO 27001信息安全管理体系认证。建立了数据安全制度规范和实施了安全技术措施，防止您的个人信息遭到未经授权的访问、修改，避免数据的损坏或丢失。我们的网络服务采取了传输层安全协议等加密技术，确保您的数据在网络传输过程的安全。
      </p>
      <p>
        （二）我们采用严格的数据处理权限控制，避免数据被违规使用；我们采用打码屏蔽等去标识化技术的多种数据脱敏方式增强个人信息在使用中的安全性；我们采用行业广泛应用的加密技术对您的个人信息进行加密保存，并通过数据隔离技术进行隔离。例如，我们对存储在我们服务器上以及您终端设备上的所有讯息进行加密处理。我们始终落实该等技术措施和组织管理方式，并可能不时加以修订完善以提升系统的整体安全性。
      </p>
      <p>
        <strong>（三）尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。请您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的帐号密码等个人信息透露给他人。</strong>
      </p>
      <p>
        （四）在发生危害网络安全的事件时，我们会按照网络安全事件应急预案，及时采取相应的补救措施。如果我们的物理设施或技术防护措施遭到破坏，导致您的个人信息被泄露、非法提供或滥用，造成您的合法权益受损，我们将严格依照法律的规定承担相应的责任。
      </p>
      <p>
        <strong>（五）在我们获悉发生了您的个人信息不幸被泄露、非法提供或滥用的个人信息安全事件后，我们将按照法律法规的要求在最迟不低于10天内及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以平台内推送通知的方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</strong>
      </p>
      <h2><a id="toc08"></a><strong>八、您的权利</strong></h2>
      <p><strong>（一）如何访问、更正您的个人信息</strong></p>
      <p>
        1、您可以进入个人头像访问相关个人信息。
      </p>
      <p>
        2、您可以通过联系上海律协修改您的个人信息。
      </p>
      <p><strong>（二）删除您的信息</strong></p>
      <p>
        <strong>您可以通过上述“（一）访问、更正您的信息”中列明的方式删除您的部分信息。</strong>
      </p>
      <p><strong>在以下情形中，您可以向我们提出删除个人信息的请求：</strong></p>
      <p><strong>1、如果我们处理个人信息的行为违反法律法规；</strong></p>
      <p>
        <strong>2、如果我们收集、使用您的个人信息，却未征得您的明确同意；</strong>
      </p>
      <p><strong>3、如果我们处理个人信息的行为严重违反了与您的约定；</strong></p>
      <p><strong>4、如果您不再使用我们的产品或服务，或您主动注销了帐号；</strong></p>
      <p><strong>5、如果我们永久不再为您提供产品或服务。</strong></p>
      <p>
        <strong>若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，并要求其及时删除（除非法律法规另有规定，或这些主体已独立获得您的授权）。
          当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。</strong>
      </p>
      <p><strong>（三）撤销授权同意的方法</strong></p>
      <p>
        <strong>除为了平台正常运营所必需提供的信息外，您可以操作改变您的授权同意范围：</strong>
      </p>
      <p>
        <strong>您可以在登录手机客户端，在手机端点击个人头像中选择系统设置-隐私设置或改变您的智能移动设备的设置等方式给予或收回您的授权同意（例如，您可以在手机客户端“系统设置-隐私设置”中收回您“通过手机号码搜索找到我”的用户同意授权）。</strong>
      </p>
      <p>
        <strong>当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</strong>
      </p>
      <p><strong>（四）如何注销您的帐号</strong></p>
      <p>
        您未在上海律协注销的，本平台暂无法注销您的帐号。若您已在律协注销，本平台将同步注销您的帐号。
      </p>
      <h2><a id="toc09"></a><strong>九、变更</strong></h2>
      <p>
        本隐私政策一旦发生任何重大变更，我们将尽合理努力向所有用户广而告之，例如通过在本平台上发布通知；但您应定期查看本隐私政策，以查看有关变更。我们还会更新本隐私政策顶部的“更新日期”和“生效日期”。您在本隐私政策更新之后继续访问或使用本平台，即视为您接受更新后的隐私政策。如果您不同意更新后的隐私政策，请您停止访问或使用本平台。
      </p>
      <h2><a id="toc10"></a><strong>十、联系方式</strong></h2>
      <p>
        与本政策相关的任何疑问、意见或请求，请发送至<a href="mailto:yhfk@lawyers.org.cn">yhfk@lawyers.org.cn</a>。一般情况下，我们会在收到您相关联系信息并核实您身份后的【15】日内回复。
      </p>
      <p>
        对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将酌情收取一定费用。对于与您的身份不直接关联的信息、无端重复信息，或者需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。
      </p>
      <h2><a id="toc11"></a><strong>十一、其他</strong></h2>
      <p>
        （一）本隐私政策仅适用于您在中国大陆（仅为本条款之目的，不含香港、澳门、台湾地区）境内使用本平台服务的情形。本隐私政策可能存在多种语言版本，如各语言版本条款出现不一致或冲突，以中文版本为准。
      </p>
      <p>
        （二）本隐私政策中的标题仅为方便及阅读而设，并不影响本隐私政策中任何规定的含义或解释。
      </p>
    </main>
    <main class="terms-container">
      <h1>上海律师用户服务条款</h1>
      <p><strong>生效日期：2021年9月1日</strong></p>
      <h2>1. 导言</h2>
      <p>1.1 欢迎使用由上海律师协会提供并由北京飞书科技有限公司（“<strong>我们</strong>”）提供运维技术支持的“上海律师”平台（“<strong>本平台</strong>”）。《上海律师用户服务条款》（“<strong>本条款</strong>”）是您与我们之间的协议，列名了您访问和使用本平台及由我们提供的相关网站、服务、应用程序、产品及内容（统称为“<strong>本服务</strong>”）须遵守的条款及条件。就本条款而言，“<strong>您</strong>”是指本服务的用户。
      </p>
      <p>
        1.2 本条款构成您与我们之间具法律约束力的协议。我们在此特别提醒您认真阅读、充分理解本条款各条款，特别是<strong>其中所涉及的免除或减轻我们责任的条款、限制您权利的条款、关于争议解决与法律适用的条款等</strong>。其中，限制您权利、免除或减轻我们责任的条款会以黑体加粗的形式提示您重点注意。
      </p>
      <p>
        1.3 <strong>您访问或使用本服务即表示您确认：您具有与我们形成达成具有约束力的合同所需的民事权利能力和民事行为能力，且您接受并同意遵守本条款。</strong>您对本服务的访问和使用还受我们的《上海律师隐私政策》的规限，包括本条款及《上海律师隐私政策》不时的增补、变更及附加协议（我们会通过合理方式告知您并向您提供）。该等条款与本条款共同构成您与我们之间达成的完整协议。
      </p>
      <p>
        1.4 我们会不时修订本条款，届时我们会尽合理努力向所有用户发出合理的通知（例如通过本平台的通知），以向您告知本条款的重大变更，您应及时关注。<strong>您在本条款更新之后继续访问或使用本服务，即视为您接受变更后的条款。如果您不同意更新后的条款，您应停止访问或使用本服务。</strong>
      </p>
      <p>
        1.5 如我们需要您遵守除本条款、《上海律师隐私政策》之外的其他条款的，该等条款的公示、发布及效力亦遵守上述约定。
      </p>
      <h2>2. 本平台及本服务</h2>
      <p>
        2.1 本平台为上海律协会员（及实习人员）提供多平台办公管理通讯及协作工具，提供包括会员服务、执业服务、协会工作、支持单人、多人参与，发送语音短信、图片和文字等即时通讯服务，和为用户提供包括但不限于文档、日历、音视频通话、视频会议、邮箱、远程办公、健康管理等功能（因版本迭代及放开用户群体的不同，具体功能以您下载本平台实际提供的功能为准）以及与其他软件互通的服务。您确认本服务是供您使用的工作工具，并非用于您个人作为日常消费的用途。
      </p>
      <p>
        2.2 在遵守本条款约定的前提下，我们授予您一项不具排他性、有限、不可转让、不可分许可且可被撤销的许可用于访问和使用本平台。我们保留一切与本平台、本服务相关的权利。<strong>您确认并同意：您在对本条款有任何违反时，我们可出于合理原因终止该许可，以避免您对我们及其他用户的进一步伤害。</strong>
      </p>
      <p>
        2.3 <strong>您应当从我们的网站或我们已经授权的第三方下载本平台以获取本服务，若您并非从我们或经我们授权的第三方获取本服务的，我们无法保证该版本的服务能够正常使用，您应自行为此种获取方式和使用行为负责。</strong>
      </p>
      <p>
        2.4 您理解并认可，<strong>本条款中所描述的功能可能以特定的方式（如：有偿付费）提供，您在访问和使用本服务时能够实际享受的服务以我们实际向您的用户帐户提供的为准。</strong>
      </p>
      <p>
        2.5 我们将不定期的对上述功能进行优化，并不断根据用户需求研发新的功能。<strong>您同意，这些功能服务可能根据用户需求的变化或我们的判断，随着服务版本不同而被优化或修改，或因定期、不定期的维护而暂缓提供。该等行为均不视为我们违反本条款约定。</strong>
      </p>
      <p>
        2.6 <strong>我们有权不时在不另行通知您的情况下，对本平台、本服务或其任何部分及相关功能进行更新、升级、修改、删除或转移。我们会尽合理努力向所有用户发出合理的通知（例如通过本平台的通知），以向您告知本服务的相关变更，您应及时关注。</strong>
      </p>
      <p>
        2.7 您在使用本平台所提供的相应功能时，应遵照我们不定时告知您的相关技术规范、安全要求等规定，以确保本服务安全、稳定地运行。
      </p>
      <h2>3. 您的帐号</h2>
      <p>
        3.1 使用本平台服务您必须注册帐号。您有权选择合法且符合我们要求的字符组合作为自己的帐号，并自行设置符合安全要求的密码。您设置的帐号、密码是您用以登录并以注册用户身份使用本平台及我们提供的其他软件及相关服务的凭证。
      </p>
      <p>
        3.2 您需通过上海律协帐号登录并使用本服务，为核实您的会员（及实习人员）身份，你授权我们通过相关主管部门获取您的帐号注册信息。
      </p>
      <p>
        3.3 <strong>您理解并承诺：您的帐号名称、头像和简介等用以使用本服务的信息及其他向我们提供的信息中不得出现违法或不良信息，未经他人许可不得使用他人名义（包括但不限于通过冒用他人姓名、名称、字号、头像等足以让人引起混淆的方式），不得恶意注册本平台帐号（包括但不限于频繁注册、批量注册帐号等行为）。您在帐号使用过程中需遵守相关法律法规，不得实施任何侵害国家利益、损害其他公民合法权益或者有害社会良好道德风尚的行为。我们有权对您的帐号信息进行审核，对于违反本条款约定的帐号信息，我们有权进行不予通过、屏蔽或删除等处理。</strong>
      </p>
      <p>
        3.4 <strong>您了解并同意，您的帐号仅限您本人使用，未经我们书面同意，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用该帐号。如果我们发现或者有合理理由认为使用者并非帐号初始注册人，我们有权在未经事先通知的情况下暂停或终止向该帐号提供服务，并有权注销该帐号，由此带来的该帐号相关数据、信息等被清空、丢失等的后果及损失，您应自行承担。</strong>
      </p>
      <p>
        3.5 您有责任维护个人帐号、密码的安全性与保密性，您应高度重视对帐号与密码的保密，在任何情况下不向他人透露帐号及密码。若发现他人未经许可使用您的帐号或发生其他任何安全漏洞问题时，您应当立即通知我们。当您使用完毕后，应安全退出。如因您保管不当等自身原因或其他不可抗因素导致遭受盗号或密码丢失，您将自行承担相应责任。
      </p>
      <p>
        3.6 在丢失帐号或遗忘密码时，您可遵照我们的申诉途径及时申诉请求找回帐号或密码。您理解并认可，我们的密码找回机制仅按照申诉单上所填资料与系统记录资料是否一致来识别申诉人是否为帐号有权使用者。
      </p>
      <p>
        3.7 <strong>您充分了解并同意，您应为自己帐号下的一切行为负责，包括该帐号所发表的任何内容以及由此产生的任何后果。您应对使用本服务时接触到的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。我们无法且不会对您因前述风险而导致的任何损失或损害承担责任。</strong>
      </p>
      <p>
        3.8 <strong>您理解并同意，出于安全性和身份识别（如帐号或密码找回申诉服务等）的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。</strong>若您未在律协注销的，本平台暂无法注销您的帐号。若您已在律协注销，本平台将同步注销您的帐号。
      </p>
      <h2>4. 您访问和使用本服务</h2>
      <p>4.1 您访问和使用本服务受到本条款和所有法律法规或国家其他相关规定的约束。出于遵照相应规定的要求，您不得：</p>
      <ul>
        <li>将本平台用于广告目的或进行任何商业推销；</li>
        <li>冒充他人或其他组织机构，或对您自己的身份或您与他人或其他组织机构的关系作出虚假或不当的陈述，包括给人以您上传、发布、传播、散布或提供的任何内容是出自本服务的印象；</li>
        <li>未经我们授权而使用或试图使用他人的帐号、服务或系统，或在本服务上创建一个虚假身份；</li>
        <li>在未经我们及相关方同意或违反适用法律法规的前提下，将本服务用于核设施、军事用途、医疗设施、交通通讯或其他限制、敏感行业或领域，或在本平台上沟通、传输、分享、发表、传播或泄露国家秘密或未经授权的商业机密；</li>
        <li>以违反任何适用法规、侵犯他人合法权益、可能造成利益冲突、危害本服务用途或违背良好社会风尚的方式使用本服务，包括但不限于在使用本服务过程中以任何方式上传、创建、传播、散布、存储或提供下列内容：
          <ul>
            <li>反对宪法所确定的基本原则，危害国家安全，颠覆国家政权，破坏国家统一，损害国家荣誉和利益的内容；</li>
            <li>煽动民族仇恨、民族歧视、破坏民族团结的，破坏国家宗教政策、宣扬邪教和封建迷信的，散布谣言、扰乱社会秩序、破坏社会稳定的内容；</li>
            <li>包含病毒、木马程式、蠕虫、逻辑炸弹或其它恶意或在技术上有害的内容；</li>
            <li>任何未经我们授权及接收方同意的广告、招揽推广材料、“垃圾邮件”、“垃圾短信”、“连锁信”、“传销”或任何其它被禁止的招揽形式内容；</li>
            <li>任何未取得第三方授权而收集、传播、储存的第三方隐私信息，包括但不限于地址、电话号码、电子邮箱地址、个人身份文件中的号码和肖像（例如：身份号码、护照号码）或信用卡号；</li>
            <li>确实或可能侵犯他人著作权、商标权等知识产权或隐私权的任何内容；</li>
            <li>诽谤、侮辱他人的内容，或威胁、骚扰他人的内容，或旨在骚扰、恐吓、威胁他人，或对他人造成痛苦、麻烦或烦恼的任何内容；</li>
            <li>涉及淫秽、猥亵、赌博、暴力、凶杀、恐怖、粗俗、恶意等令人反感的任何内容，或故意煽动或引起用户对立情绪的内容，尤其是故意发布的煽动性文章；</li>
            <li>构成、鼓励或教唆犯罪、危险活动或自残的任何内容；</li>
            <li>种族主义或歧视性的内容，包括对种族、民族、宗教、年龄、性别、残疾或性取向的歧视；</li>
            <li>我们判断认为属于令人反感的，或可能使我们、本服务或其用户面临任何类型的伤害或法律责任的内容。</li>
          </ul>
        </li>
      </ul>
      <p>4.2 您访问和使用本服务时不得从事损害本服务或我们利益的行为，包括但不限于：</p>
      <ul>
        <li>经销、许可、转让、租赁或出售本服务的全部或部分，或本服务任何衍生作品的全部或部分；</li>
        <li>基于本服务创作任何衍生作品；</li>
        <li>将本服务（包括本服务中的任何文档、图表、文件或程序任何部分）或本服务的任何衍生作品的全部或部分整合进任何其它程序或产品；</li>
        <li>对本服务（包括本服务中的任何文档、图表、文件或程序等任何部分）进行更改、改编、转化、反向工程、反汇编或反编译。获取或尝试获取本服务或其任何衍生作品中包含的任何源代码、算法、方法或技术；</li>
        <li>干涉或试图干涉本服务的正常运作（包括但不限于使用自动化脚本等方式收集来自本服务的信息或与本服务互动，通过非我们开发或授权的第三方程序、插件、外挂等工具使用本服务或制作、发布、传播上述工具，限制或阻止他人使用本服务）、破坏我们的网站或连接到本服务的任何网络，绕开或破坏我们用于禁止或限制本服务访问的任何措施。</li>
      </ul>
      <h2>5. 第三方应用</h2>
      <p>5.1 经我们允许的第三方应用可以接入本平台并向您提供服务，您可以在本平台的工作台中通过添加应用的方式使用第三方服务。在使用第三方服务的过程中，您除需遵守本条款的约定外，还需遵守第三方的用户协议、隐私政策等相关条款。您理解并认可，第三方服务由第三方服务方提供，除法律法规和本条款另有规定外，我们不对第三方服务承担任何责任。</p>
      <p>5.2 <strong>您了解并同意，我们可能会对本服务及第三方应用政策做出调整，该等调整可能会导致对第三方服务产生影响（如导致第三方服务无法继续在本平台提供，或第三方应用的服务功能受限），除法规另有明确规定外，我们不承担相应责任。</strong></p>
      <p>5.3 您在选择使用第三方服务前应充分了解第三方应用的产品功能、服务协议及隐私政策，再选择是否开通第三方服务。</p>
      <h2>6. 知识产权</h2>
      <p>
        6.1 您所持有的商标、专利以及您创作作品的知识产权归您所有，我们不会对您的上述知识产权主张任何所有性权利。</p>
      <p>
        6.2 我们尊重知识产权，并要求您同样予以尊重。作为访问和使用本服务的先决条件，您同意不会在本服务的使用中侵犯任何知识产权（例如未经同意即擅自上传或分享他人受著作权权保护的材料）。<strong>如您在使用本服务的过程中存在任何侵犯知识产权的行为，或被任何第三方指称存在侵犯知识产权的嫌疑的，我们有权酌情在通知或不通知您的情况下删除或屏蔽相应内容，并有权屏蔽及/或终止相关用户帐号。</strong>
      </p>
      <h2>7. 内容</h2>
      <p>
        7.1 您使用我们的内容
      </p>
      <p>
        7.1.1 就您与我们之间而言，本服务中的内容（不包括<strong>用户内容</strong>，定义见下文），除有特别说明外，包括本服务的文本、软件、标志、专利、商标、服务商标、著作权内容、外观、声音、图片等所有相关的内容（前述各项统称为“<strong>我们的内容</strong>”），其所有权及知识产权等相关权利均由我们拥有或拥有相关授权许可。对于我们的内容，您应按照本条款所允许的方式、通过本服务规定的功能计划进行使用。
      </p>
      <p>
        7.1.2 除本条款明示允许的目的外，您不应将我们的内容或源自本服务的任何其他内容用于其他任何目的。<strong>未经我们或我们的许可方事先同意，您不得为任何目的使用、复制、转载、传播、播放、展示、出售、许可或以其它本款未明示允许的方式使用任何我们的内容。</strong>我们和我们的许可方保留未明示授予您的一切权利。
      </p>
      <p>
        <strong>7.1.3 您确认并同意，您查看他人在本服务上提供的内容（包括任何用户内容）时，您应自行承担相关风险。您亦同意，未经相应权利人的明示同意，您不得为任何目的使用、复制、转载、传播、播放、展示、出售、许可或以其它未明示允许的方式使用该等内容。</strong>
      </p>
      <p>
        <strong>7.1.4 本服务中可能包含能跳转其它在线服务或资源的链接，该等在线服务或资源可能是由第三方服务提供方提供。我们无法控制您对该等第三方服务或资源的使用，因此除非本条款另有约定，您使用第三方服务或资源的行为受您和相关第三方之间协议约束，我们不对您使用第三方服务或资源的行为承担任何责任。该等链接的存在不代表我们认可这些第三方服务或资源的合法性、安全性。</strong>
      </p>
      <p>
        <strong>7.1.5我们可能在您访问或使用本服务的过程中向您发送、展示广告或其他信息（包括商业或非商业信息）。我们将按照相关法律法规的要求展开广告业务，您应当谨慎判断广告等信息的真实性、可靠性。</strong>
      </p>
      <p>7.2 您的用户内容</p>
      <p>7.2.1 用户可能获准向本服务或通过本服务上传、发布、提交或发送讯息、聊天、文档、日历信息、通讯或任何其它内容（“<strong>用户内容</strong>”）。用户还可在用户内容上叠加或添加我们提供的图表、标签、表情符号和其它元素（“<strong>我们的元素</strong>”），并通过本服务传播用户内容。除非法律法规明确要求，否则我们不会审核用户内容（包括包含了我们的元素的用户内容）。对于任何用户或其他许可方提交到本服务，或通过本服务发送的任何用户内容以及其中表达的任何意见、推荐或建议，我们不持任何立场。</p>
      <p>
        <strong>7.2.2 如果您向本服务或通过本服务上传、传播、提供您的用户内容，出于实现本服务功能运行、改善本服务以及您同意且与适用法律、本条款和《上海律师隐私政策》相符的其它目的之必要，我们（及我们的合同方和供应商）将使用、复制、下载或展示您的用户内容，我们不会超越上述目的和范围使用您的用户内容。如果您与本服务的其他用户分享您的用户内容，即表示您同意向这些用户授予不受限制且免费使用您用户内容的权利（包括任何知识产权等相关权益），除非您明确地向对方说明了该等限制，但该等说明及限制仅能约束您与对方。您承诺仅向本服务或通过本服务上传、传播、提供及分享您愿意并能够授予上述权利的用户内容。</strong>
      </p>
      <p>7.2.3 本服务并非存储服务，针对您的用户内容，或其他用户向本服务或通过本服务上传、传播或提供的任何其它内容，我们不能亦不会提供备份。请注意，即使在用户内容从本服务中删除后，其他用户仍可能独立地继续使用及允许他人使用您的该等用户内容（例如，该用户可能已将您用户内容的副本保存在其自己帐号中）。</p>
      <p>7.2.4 您通过本服务上传、传播或提供用户内容、或与本服务的其他用户通讯时，您应该遵守上文“<strong>您访问和使用本服务</strong>”一节中所载的要求。<strong>您保证，您通过本服务上传、传播或提供的任何用户内容均符合上述要求，不存在违背任何使用法规或其他相关规定的情况。您应对您自己的用户内容及您在本服务或向本服务发布、提交或发送您的用户内容的后果承担全责。</strong>如果我们认为您的用户内容不符合本条款的约定，<strong>我们有权在不事先通知的情况下，删除您的用户内容（包括您在本平台上发布的任何讯息、帖子）。</strong></p>
      <p><strong>7.2.5 我们对用户提交并已获授权的第三方发布的任何内容概不负责。</strong></p>
      <p>7.2.6您通过本服务上传、传播或提交用户内容，即表示您确认：您拥有该用户内容的所有性权利，或您是在获得了该用户内容的所有人允许或授权的情况下通过本服务上传、传播或提交的。<strong>如我们发现用户内容包含任何侵权材料或任何第三方向我们主张用户内容存在侵权情形的，我们有权采取删除、屏蔽等合理措施进行处理。根据我们的政策，在适当的情况下且由我们自行酌情决定，我们将禁用或终止存在侵犯他人合法权益行为的帐号。</strong></p>
      <p>7.2.7 您确认，我们并无义务预审、监控、审查或编辑您和其他用户在本平台上撰写或发布的任何内容（包括用户内容）。<strong>您进一步理解并确认，您可能会在本服务的使用中接触到冒犯性、不雅或令人反感的其他内容（包括用户内容），您可以联系我们对上述内容进行举报，您同意放弃您就此对我们享有或可能享有的任何法律救济。</strong></p>
      <p>7.2.8若您欲投诉其他用户上传的信息和材料，请联系我们，联系方式为<a href="mailto:yhfk@lawyers.org.cn">yhfk@lawyers.org.cn</a>。</p>
      <h2>8. 用户个人信息保护</h2>
      <p>8.1 我们与您一同致力于您个人信息（即能够独立或与其他信息结合后识别用户身份的信息）的保护，保护用户个人信息是我们的基本原则之一。<strong>在访问及使用本软件及本服务的过程中，您可能需要提供您的个人信息（包括但不限于姓名、电话号码、邮箱、设备信息等），以便我们向您提供相应的技术支持和服务。为了更好地为您提供服务，我们还可能与我们的关联方共享您的信息，我们承诺该等信息共享仅出于更好地为您提供本服务之目的，并不会超越上述范围。</strong>我们将运用加密技术、匿名化处理等其他与本服务相匹配的技术措施及其他安全措施来保护您的个人信息安全。
      <p>8.2 更多关于用户个人信息保护的内容，请参见《上海律师隐私政策》。</p>
      <h2>9. 违约与赔偿</h2>
      <p>
        <strong>9.1 如果您违反本条款和/或其他您应遵守的其他条款，我们有权根据独立判断，视情况在不经事先通知您的情况下采取合理的处置措施，包括但不限于限制、暂停、终止您使用本服务的部分或全部功能，屏蔽或删除您上传、传播或提供的用户内容等，您需自行承担由此导致的后果及损失。</strong>
      </p>
      <p>
        <strong>9.2 因您违反本条款和/或其他您应遵守的其他条款约定，引起第三方投诉、诉讼索赔等情况的，您应当自行处理并承担全部法律责任。</strong>
      </p>
      <p>
        <strong>9.3 如果您在使用本服务过程中违反本条款和/或其他您应遵守的其他条款约定的情况，在适用法律允许的情况下，您同意根据本条款或相关法律法规的规定，向我们、我们的关联方、许可方及被许可方等权益受损方作出足额赔偿，赔偿范围包括但不限于：因您的行为导致我们及相关方向任何第三方支付的赔偿、遭受的国家机关罚款等。</strong>
      </p>
      <h2>10. 责任限制</h2>
      <p>
        <strong>10.1 根据法律法规规定，对于我们不得免除、限制的义务与责任，我们不会通过本条款的约定进行免除或限制，包括我们对消费者用户依法应履行的义务，因我们的过失或我们的雇员、代理人或分包商的过失而导致的人身伤害及死亡的损失赔偿责任，以及因欺诈或虚假陈述导致的相应责任。</strong>
      </p>
      <p>
        <strong>10.2 在符合前述规定的前提下，我们不就下列情况向您承担任何责任：</strong>
      </p>
      <ul>
        <li>您遭受的任何利润损失（无论直接或间接产生）；</li>
        <li>您遭受的任何商誉损失；</li>
        <li>您遭受的任何机会损失；</li>
        <li>您遭受的任何数据丢失；</li>
        <li>您可能招致的任何间接或附带损失；或</li>
        <li>您因下列情况而招致的任何损失或损害：
          <ul>
            <li>您对任何广告之完整性、准确性或存在性的任何依赖，或因您与在本服务上刊登广告的任何广告商、赞助商建立或达成的任何关系或交易；</li>
            <li>我们按照本条款约定对本服务作出的任何变更、调整，或暂时停止提供本服务（或本服务中的任何功能）；</li>
            <li>您未能向我们提供准确的个人信息、帐号等信息；或</li>
            <li>您未能保障您密码或帐号资料的安全及保密性。</li>
          </ul>
        </li>
      </ul>
      <p>
        10.3 我们将尽最大努力使本服务安全、稳定，但是<strong>您理解，我们不能随时预见和防范所有的技术风险以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、第三方网站等原因可能导致的服务中断、不能正常使用以及其他类似情况。</strong>您需要配置您自己的计算机设备、网络设置、计算机程序等，以访问和使用本服务。您应为您的设备自行配置防毒程序。
      </p>
      <p>
        <strong>10.4 任何我们承担损失赔偿责任的金额以过去12个月您或您相应的企业用户向我们支付的金额为限。</strong>
      </p>
      <p>
        <strong>10.5即使您已经事先告知，或我们本应意识到可能产生任何相关的损失，我们向您承担的责任同样适用上述限制。</strong>
      </p>
      <p>
        <strong>10.6对于您使用本服务过程中存储、传输、提供、发布、传播的任何内容及其它通讯数据，如因我们的原因导致上述内容被删除、未被储存或产生崩溃或毁坏，我们将尽力进行补救。您理解并同意，在我们尽到合理义务后仍未能避免因此给您造成损失的，对于您产生的相关损失我们向您承担的责任也适用上述限制。</strong>
      </p>
      <h2>11. 数据流量及紧急服务</h2>
      <p>
        11.1 在移动应用上使用本服务时可能会用到您向您的移动网络运营商订购的数据流量包中的部分数据流量，在国际漫游的情况下可能会使费用大幅增加。您应始终了解这些情况，<strong>您在使用本服务时产生的任何移动费用（包括短信及数据费用）均由您自行承担。若您不确定这些费用，您应在使用本服务前咨询您的服务提供商。</strong>
      </p>
      <p>
        11.2 本服务并不提供报警、消防或医院等紧急服务的接入，也不联系公共安全响应点。您应确保能通过手机、固定电话或其它设备进行紧急联系。
      </p>
      <h2>12. 其它条款</h2>
      <p>
        12.1 <strong><em>完整协议。</em>本条款、本条款中所提及的适用于您的其他条款以及将来我们通过合理方式告知您需适用的其他条款共同构成您与我们那之间的完整法律协议，约束您与我们之间的服务关系。上述条款中有变更、更新、增补的，自该等变更、更新、增补生效后，其所替代的旧版本自动失效。</strong>
      </p>
      <p>
        <strong>12.2 无放弃与可分割性。</strong>我们暂时未主张或强制执行本条款的任何规定，不应被视为我们豁免该等规定或放弃该等权利。如果本条款中任意约定被判决或裁定属于无效，则该约定视为从本条款中删除，不影响本条款中其它约定的效力。
      </p>
      <p>
        <strong>12.3 转让。</strong>未经我们事先书面同意，您不得向任何第三方转让您在本条款项下的任何权利或义务。
      </p>
      <p>
        <strong>12.4 争议解决与法律适用。本条款的解释、适用与争议解决，均应依照中华人民共和国大陆地区法律。本条款的签署地为上海市徐汇区，因本条款所引发的争议由上海市徐汇区有管辖权的人民法院管辖。</strong>
      </p>
      <p>
        <strong>12.5 语言。本条款可能存在多种语言版本，如各语言版本条款出现不一致或冲突，以中文版本为准。</strong>
      </p>
      <p><strong>12.6 联系我们。 如有任何疑问，请您联系</strong> <a href="mailto:yhfk@lawyers.org.cn">yhfk@lawyers.org.cn</a>。</p>
    </main>
    <footer class="footer"
            v-if="isShowPrivacy">
      <van-button style="width: 90%; margin: 0 auto"
                  @click="toDownloadPage">返回</van-button>
      <!-- <van-button style="width: 66%;" type="info" :disabled="isDisabled" @click="toDownloadPage">同意隐私政策和用户协议<span v-if="time">({{time}})</span></van-button> -->
    </footer>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isDisabled: true,
      isShowPrivacy: true,
      timer: null,
      time: 10,
      isShow: false,
    };
  },
  components: {},
  created () {
    // this.isWeiChart();
    // const times = 10 * 1000;
    // this.timer = setInterval(() => {
    // 	this.time--;
    // 	if (this.time <= 0) {
    // 		clearInterval(this.timer);
    // 		this.isDisabled = false;
    // 	} 
    // }, 1000);
    // setTimeout(() => {
    //   this.isDisabled = false;
    // }, times);
  },
  methods: {
    toDownloadPage () {
      this.$router.push("/iosclient");
    },
    // 判断浏览器是否是微信浏览器
    isWeiChart () {
      var ua = navigator.userAgent.toLowerCase();
      this.isShow = ua.match(/MicroMessenger/i) == "micromessenger";
    },
    // 蒙版点击
    touch () {
      this.isShow = false;
    },
  }
};
</script>
<style lang='scss' scoped>
.box {
  // position: relative;
  padding: 0 8px;
  padding-bottom: 52px;
  font-size: 16px;
}
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-content: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  background-color: #fff;
  box-shadow: 0 0 8px 8px #ccc;

  /deep/ .van-button {
    font-size: 0.42rem;
  }
}

.isWeiChart {
  display: flex;
  justify-content: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 2rem 0 0 0.5rem;
  font-size: 0.5rem;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
}
.inner-box {
  width: 5.68rem;
  height: 4.75rem;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-image: url("~@src/assets/img/isWeiChart.png");
}
</style>